import { apiUrl } from "./apiUrl";

/**
 * Fetch saved Travel India progress for the logged-in user so the game can
 * resume on the round they left off.
 */
export async function fetchTravelGameStatus(adminToken, user) {
  const resp = await fetch(apiUrl("/gameProgressStatus"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify({ userId: user.userId }),
  });

  const data = await resp.json();
  if (!resp.ok || !data?.success) {
    throw new Error(data?.message || "Failed to load game progress");
  }
  return data;
}

/**
 * Persist running progress (points, elapsed time, resume round) plus the row
 * for the round that just finished.
 */
export async function saveTravelGameProgress(adminToken, user, payload) {
  const resp = await fetch(apiUrl("/gameProgress"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify({
      userId: user.userId,
      email: user.email || "",
      name: user.name || "",
      ...payload,
    }),
  });

  const data = await resp.json().catch(() => null);
  if (!resp.ok || !data?.success) {
    throw new Error(data?.error || "Failed to save progress");
  }
  return data;
}
